import { useEffect } from "react";
import ReactGA from "react-ga4";
import "./App.css";
import Profile from "./components/Profile";
import Experience from "./components/Experience";
import Projects from "./components/Projects";
import Expertise from "./components/Expertise";
import Education from "./components/Education";
import Footer from "./components/Footer";

function App() {
  useEffect(() => {
    ReactGA.initialize("G-2TXC272HEH");
    ReactGA.send({ hitType: "pageview", page: "/", title: "Resume" });
  }, []);

  return (
    <div className="min-h-screen bg-bg text-fg">
      <main className="mx-auto max-w-[920px] px-5 sm:px-8 py-7 sm:py-10">
        <Profile />

        <hr className="my-7 sm:my-9 border-0 h-px bg-rule" />

        <Experience />

        <hr className="my-7 sm:my-9 border-0 h-px bg-rule" />

        <Projects />

        <hr className="my-7 sm:my-9 border-0 h-px bg-rule" />

        <Expertise />

        <hr className="my-7 sm:my-9 border-0 h-px bg-rule" />

        <Education />

        <hr className="mt-7 sm:mt-9 mb-5 border-0 h-px bg-rule" />

        <Footer />
      </main>
    </div>
  );
}

export default App;
